export interface StatusOptions {
  status_value: string;
  label: string;
}

export interface GeometryType {
  name: string;
  value: string;
}

export const StatusOptions: StatusOptions[] = [
  {
    status_value: "1",
    label: "Running",
  },
  {
    status_value: "2",
    label: "Success",
  },
  {
    status_value: "-1",
    label: "Failed",
  },
  {
    status_value: "-2",
    label: "Stopped",
  },
  {
    status_value: "0",
    label: "Started",
  },
  {
    status_value: "3",
    label: "Sync in Process",
  },
  {
    status_value: "4",
    label: "Synced",
  },
  {
  status_value: "-3",
  label: "Pending Start",
}
]

export const GEOMETRY_TYPES: GeometryType[] = [
  // {  name: 'point', value: 'Point' },
  {  name: 'Line', value: 'line' },
  {  name: 'Polygon', value: 'polygon' }
];
